// @flow
import { useCallback } from 'react';
import { stylesheet } from 'typestyle';
import classnames from 'classnames';

import { savedHeartImage, unsavedHeartImage } from '../utils/favorites';

import { linkBlueText } from '@src/styles/general';

type TProps = {
  selected: boolean,
  className: string,
  altText: string,
  onClick: () => void
};

const css = stylesheet({
  button: {
    padding: 10,
    backgroundColor: 'transparent',
    height: 'auto',
    lineHeight: '18px',

    $nest: {
      '&:focus': {
        boxShadow: `0 0 5px ${linkBlueText}`
      },
      '&:hover, &:active, &:focus': {
        backgroundColor: 'transparent'
      }
    }
  }
});

function FavoriteIcon ({ selected, className, altText, onClick }: TProps) {
  const handleClick = useCallback(
    (
      e:
        | SyntheticMouseEvent<HTMLImageElement>
        | SyntheticKeyboardEvent<HTMLImageElement>
    ) => {
      e.stopPropagation();
      e.preventDefault();

      onClick();
    },
    [onClick]
  );

  const handleKeyPress = useCallback(
    (e: SyntheticKeyboardEvent<HTMLImageElement>) => {
      if (e.key == 'Enter') {
        handleClick(e);
      }
    },
    [handleClick]
  );

  return (
    <button
      className={classnames('basic-button', css.button, className)}
      onClick={handleClick}
      onKeyPress={handleKeyPress}>
      <img src={selected ? savedHeartImage : unsavedHeartImage} alt={altText} />
    </button>
  );
}

FavoriteIcon.defaultProps = {
  selected: false,
  altText: 'Save this item as a favorite'
};

export default FavoriteIcon;
